let PHPHOST = ""
let MAPI = ""
let YLKAPI = ""
let USERAPI = ""
let API = ""
let MallApi = ""
let CDN = ""
let DEFAULT_SHOP_LOGO = ""
let ENV = ""
let EXAPI = ""
let EXAPI1 = ""
const host = window.location.host
if (host === "m.ylcool.com") {
  PHPHOST = "https://www.ylcool.com/" //生产环境
  MAPI = "https://m.ibuychem.com"
  YLKAPI = "https://m.ylcool.com/"
  USERAPI = "https://user.ibuychem.com/"
  API = "https://www.ibuychem.com/"
  MallApi = "https://cn.ibuychem.com/"
  DEFAULT_SHOP_LOGO =
    "https://style.ibuychem.com/wiseshop/pc/images/default_goods.jpg"
  CDN = "https://wwwimg-cdn.ibuychem.com/"
  ENV = "production"
  EXAPI = "https://ex.hzeyun.com/"
  EXAPI1 = "https://www.hzeyun.com/"
} else {
  PHPHOST = "https://stg.ylcool.com/" //开发环境
  MAPI = "https://m-stg.ibuychem.com"
  YLKAPI = "https://m-stg.ylcool.com/"
  USERAPI = "https://user-stg.ibuychem.com/"
  API = "https://www-stg.ibuychem.com/"
  MallApi = "https://cn-stg.ibuychem.com/"
  DEFAULT_SHOP_LOGO =
    "https://style-stg.ibuychem.com/wiseshop/pc/images/default_goods.jpg"
  ENV = "dev"
  EXAPI = "https://ex-stg.hzeyun.com/"
  EXAPI1 = "https://www-stg.hzeyun.com/"
  if (window.location.host === "m-stg.ylcool.com") {
    ENV = "test"
  } else {
    ENV = "dev"
  }
}

export default {
  MAPI,
  PHPHOST,
  YLKAPI,
  USERAPI,
  API,
  MallApi,
  DEFAULT_SHOP_LOGO,
  CDN,
  ENV,
  EXAPI,
  EXAPI1
}



// WEBPACK FOOTER //
// ./src/common/config.js